export enum Gender {
  MALE = 'MALE',
  FEMALE = 'FEMALE',
  OTHER = 'OTHER',
  PREFER_NOT_TO_SAY = 'PREFER_NOT_TO_SAY',
}

export const GENDER_OPTIONS = [
  { value: Gender.MALE, label: 'чоловіча' },
  { value: Gender.FEMALE, label: 'жіноча' },
  { value: Gender.OTHER, label: 'інша' },
  { value: Gender.PREFER_NOT_TO_SAY, label: 'не вказано' },
];

export enum MaritalStatus {
  SINGLE = 'SINGLE',
  MARRIED = 'MARRIED',
  DIVORCED = 'DIVORCED',
  WIDOWED = 'WIDOWED',
}

export const getMaritalStatusLabel = (status: MaritalStatus, gender: Gender) => {
  const isFemale = gender === Gender.FEMALE;
  switch (status) {
    case MaritalStatus.SINGLE:
      return isFemale ? 'незаміжня' : 'неодружений';
    case MaritalStatus.MARRIED:
      return isFemale ? 'заміжня' : 'одружений';
    case MaritalStatus.DIVORCED:
      return isFemale ? 'розлучена' : 'розлучений';
    case MaritalStatus.WIDOWED:
      return isFemale ? 'вдова' : 'вдівець';
    default:
      return '';
  }
};

export const getMaritalStatusOptions = (gender: Gender) => {
  return [
    {
      value: MaritalStatus.SINGLE,
      label: getMaritalStatusLabel(MaritalStatus.SINGLE, gender),
    },
    {
      value: MaritalStatus.MARRIED,
      label: getMaritalStatusLabel(MaritalStatus.MARRIED, gender),
    },
    {
      value: MaritalStatus.DIVORCED,
      label: getMaritalStatusLabel(MaritalStatus.DIVORCED, gender),
    },
    {
      value: MaritalStatus.WIDOWED,
      label: getMaritalStatusLabel(MaritalStatus.WIDOWED, gender),
    },
  ];
}
